import React from 'react';
import { useTranslation } from 'react-i18next';

const Step1BasicInfo = ({
  formData = {},
  onChange = () => {},
  errors = {},
}) => {
  const { t } = useTranslation();

  const baseInputClass =
    'w-full p-3 rounded-lg border transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primaryAccent text-gray-800 dark:text-gray-100 bg-white dark:bg-gray-800';

  const getBorderClass = (hasError) =>
    hasError ? 'border-red-500' : 'border-gray-300 dark:border-gray-600';

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
        {t('partnerJoin.step1.title')}
      </h2>

      {/* Nama Organisasi */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step1.name')} <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="name"
          value={formData.name || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.name)}`}
        />
        {errors.name && (
          <p className="text-sm text-red-500 mt-1">{errors.name}</p>
        )}
      </div>

      {/* Email */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step1.email')} <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          name="email"
          value={formData.email || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.email)}`}
        />
        {errors.email && (
          <p className="text-sm text-red-500 mt-1">{errors.email}</p>
        )}
      </div>

      {/* Telepon */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
          {t('partnerJoin.step1.phone')} <span className="text-red-500">*</span>
        </label>
        <input
          type="tel"
          name="phone"
          value={formData.phone || ''}
          onChange={onChange}
          className={`${baseInputClass} ${getBorderClass(errors.phone)}`}
        />
        {errors.phone && (
          <p className="text-sm text-red-500 mt-1">{errors.phone}</p>
        )}
      </div>
    </div>
  );
};

export default Step1BasicInfo;
